import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LoginPage } from './components/auth/LoginPage';
import { RegisterPage } from './components/auth/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { AdminPage } from './pages/AdminPage';
import LandingPage from './components/onboarding/LandingPage';
import GameApp from './components/GameApp';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import { PackEditorPage } from './pages/PackEditorPage';
import TutorialPage from './pages/TutorialPage';
import ReplayPage from './pages/ReplayPage';
import { ShopPage } from './pages/ShopPage';
import { ShopSuccessPage } from './pages/ShopSuccessPage';
import { BillingPage } from './pages/BillingPage'; // [NEW]
import { TesterDashboardPage } from './pages/TesterDashboardPage'; // [NEW]
import { Toaster } from 'react-hot-toast';
import MainLayout from './components/layout/MainLayout';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <div className="text-white text-center mt-20">Chargement...</div>;

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

// Admin Route Component
const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) return <div className="text-white text-center mt-20">Chargement...</div>;

  if (!isAuthenticated || !isAdmin) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            } />

            <Route path="/admin" element={
              <AdminRoute>
                <AdminPage />
              </AdminRoute>
            } />

            {/* Game Route - Public access for Guest Play */}
            <Route path="/game" element={<GameApp />} />

            {/* Replay Route */}
            <Route path="/replay/:gameId" element={
              <ProtectedRoute>
                <ReplayPage />
              </ProtectedRoute>
            } />

            {/* Root route - Landing Page */}
            <Route path="/" element={
              <LandingPage
                onStartGame={() => window.location.href = '/game' + window.location.search}
                onShowTutorial={() => { }}
              />
            } />

            <Route path="/pack-editor/:packId" element={
              <ProtectedRoute>
                <PackEditorPage />
              </ProtectedRoute>
            } />

            <Route path="/tutorial" element={<TutorialPage />} />

            <Route path="/shop" element={
              <ProtectedRoute>
                <ShopPage />
              </ProtectedRoute>
            } />
            <Route path="/shop/success" element={<ShopSuccessPage />} />

            <Route path="/account/billing" element={
              <ProtectedRoute>
                <BillingPage />
              </ProtectedRoute>
            } />

            <Route path="/test" element={
              <ProtectedRoute>
                <TesterDashboardPage />
              </ProtectedRoute>
            } />
          </Route>
        </Routes>
        <Toaster position="top-right" />
      </Router>
    </AuthProvider>
  );
}

export default App;
